<template>
  <div class="product-item-step-bd product-msg clear">
    <div class="product-info">
      <el-form :model="form" ref="form" class="form-section">
        <!-- 总部管理员的品牌排在这里 -->
        <el-form-item v-if="isAdmin" :label="$t('dms_product_item_step_info.guo_jia')" prop="country" :rules="rules.country">
          <custom-select
            v-model="form.country"
            filterable
            url="factoryDeliveryPlaceSelectList"
            :props="{ label: 'placeCodeName', value: 'placeName' }"
            @change="onChangeCountry"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item v-if="isAdmin" :label="$t('dms_product_item_step_info.ISTzhan_dian')" prop="websiteCode" :rules="rules.websiteCode">
          <custom-select
            v-model="form.websiteCode"
            url="websiteSelectList"
            :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
            filterable
            :props="{ label: 'websiteName', value: 'websiteCode' }"
            @change="onChangeWebsiteName"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_info.chan_pinSN')" prop="productSn" :rules="rules.productSn">
          <el-input v-model="form.productSn" :disabled="Boolean(productId)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_info.chan_pin_xing_hao')" prop="productCode" :rules="rules.productCode">
          <custom-select
            :auto="false"
            filterable
            :listener="form.websiteCode"
            :disabled="Boolean(productId)"
            url="productCodeSelectList"
            v-model="form.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :params="{ websiteCode: form.websiteCode }"
            @change="onChangeProductCode"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_info.chan_pin_ming_cheng')" prop="productName" :rules="rules.productName">
          <el-input :disabled="!isAdmin" v-model="form.productName"></el-input>
        </el-form-item>
        <template v-if="!isAdmin">
          <el-form-item :label="$t('dms_product_item_step_info.ERPbian_ma')" prop="productErpCode" :rules="rules.productErpCode">
            <el-input v-model="form.productErpCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_product_item_step_info.ERPming_cheng')" prop="productErpName" :rules="rules.productErpName">
            <el-input v-model="form.productErpName"></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('label_product_class')" prop="productClass" :rules="rules.productClass">
            <custom-select :disabled="!isAdmin" code="dms_product_class" v-model="form.productClass" width="100%"></custom-select>
          </el-form-item> -->
        </template>
        <el-form-item :label="$t('dms_product_item_step_info.shun_xu_pai_xu')" prop="showOrder">
          <el-input v-model.number="form.showOrder"></el-input>
        </el-form-item>
        <!-- 系统管理员的品牌排在这里 -->
        <el-form-item :label="$t('Common.com_status')" prop="productState" :rules="rules.productState">
          <custom-select code="cloud_valid_invalid_state" v-model="form.productState" :disabled="isFactory" width="100%"></custom-select>
        </el-form-item>
        <el-form-item v-if="isAdmin" :label="$t('dms_product_item_step_info.cpzcgn')" prop="supportFunc" :rules="rules.supportFunc">
          <custom-select :multiple="true" code="iot_product_support_func" v-model="supportFunc"></custom-select>
        </el-form-item>
        <el-form-item prop="productDesc" :rules="rules.productDesc" :label="$t('dms_product_item_step_info.chan_pin_miao_shu')">
          <el-input :disabled="!isAdmin" type="textarea" v-model="form.productDesc"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="line"></div>
    <div class="product-r">
      <div class="product-doc">
        <div class="title">{{ $t('dms_product_item_step_info.chan_pin_wen_dang') }}</div>
        <t-upload
          ref="productFile"
          :limit="4"
          type="file"
          :bizId="form.productCodeId"
          bizType="dms.product.doc"
          v-model="instructionsList"
          :tip="$t('dms_product_item_step_info.zcdgwj2Myn')"
          :autoUpload="false"
          :disabled="true"
        ></t-upload>
      </div>
      <div class="product-img">
        <div class="title">{{ $t('dms_product_item_step_info.chan_pin_zhu_tu') }}</div>
        <t-upload ref="productMainImage" :bizId="form.productCodeId" bizType="dms.product.icon" v-model="productIconList" type="text" :autoUpload="false" :disabled="true"></t-upload>
      </div>
      <div class="product-img">
        <div class="title">{{ $t('dms_product_item_step_info.chan_pin_hua_ce') }}</div>
        <t-upload ref="productImage" :limit="4" :bizId="form.productCodeId" bizType="dms.product.atlas" v-model="picList" :autoUpload="false" :disabled="true"></t-upload>
      </div>
    </div>
    <div class="footer">
      <el-button type="primary" @click="saveHandler">{{ $t('Common.com_save') }}</el-button>
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button v-if="isAdmin" type="primary" @click="onStep">{{ $t('dms_product_item_step_info.xybcpcs') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';

export default {
  props: {
    productId: [String, Number],
    isAdmin: Boolean,
  },
  components: {
    tUpload,
  },
  computed: {
    rules() {
      return {
        productSn: [
          {
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20]),
          },
          {
            type: 'string',
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        productCode: [
          {
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20]),
          },
          {
            type: 'string',
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        productName: {
          max: 30,
          message: this.$t('Common.com_rules_length_max', [30]),
        },
        websiteName: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required'),
        },
        country: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required'),
        },
        productState: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required'),
        },
        allowRegister: {
          type: 'number',
          required: true,
          message: this.$t('Common.com_required'),
        },
        productDesc: {
          max: 200,
          message: this.$t('Common.com_rules_length_max', [200]),
        },
        productErpCode: {
          max: 30,
          message: this.$t('Common.com_rules_length_max', [30]),
        },
        productErpName: {
          max: 30,
          message: this.$t('Common.com_rules_length_max', [30]),
        },
      };
    },
    // 是否为总部角色
    isFactory() {
      // PF-平台，HQ-总部，SC-售后公司，JV-代理，CO-大客户，CS-客户
      const bizType = this.$store.state.userInfo.bizType;
      return bizType === 'HQ';
    },
    supportFunc: {
      get() {
        return this.form.supportFunc ? this.form.supportFunc.split(',') : [];
      },
      set(value) {
        this.form.supportFunc = value.join(',');
      },
    },
  },
  data() {
    return {
      data: {},
      form: {
        productCode: '',
        productCodeId: '',
        productName: '',
        websiteCode: '',
        websiteName: '',
        country: '',
        countryCode: '',
        showOrder: 0,
        productState: '1',
        productDesc: '',
        productErpCode: '',
        productErpName: '',

        // 产品支持功能
        supportFunc: '',
        productSn: '',
      },
      instructionsList: [],
      picList: [],
      productIconList: [],
    };
  },
  mounted: function () {
    setTimeout(() => {
      this.getProductDetail();
    }, 100);
  },
  methods: {
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    // 下一步
    async onStep() {
      this.$refs.form.validate(async (val) => {
        if (val) {
          if (this.productId) {
            await this.save();
            this.$emit('step', {
              name: 'info',
              productId: this.productId,
              productCode: this.data.productCode,
              productSn: this.data.productSn,
            });
          } else {
            const data = await this.create();
            this.$emit('step', {
              name: 'info',
              productId: data.data.productId,
              productCode: data.data.productCode,
              productSn: data.data.productSn,
            });
          }
        }
      });
    },
    create() {
      return this.$postJSON(apis.ProductInfoAdd, this.getCreateReqData());
    },
    save() {
      return this.$postJSON(apis.ProductInfoUpdate, this.getEditReqData());
    },
    async saveHandler() {
      this.$refs.form.validate(async (val) => {
        if (val) {
          if (this.productId) {
            await this.save();
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            if (!this.isAdmin) {
              this.jump('/product/list', {}, true);
            }
          } else {
            const data = await this.create();
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('update', data.data);
          }
        }
      });
    },
    getCreateReqData() {
      return {
        ...this.form,
        instructionsList: this.instructionsList,
        picList: this.picList,
        productIconList: this.productIconList,
      };
    },
    getEditReqData() {
      const data = this.getCreateReqData();
      return {
        ...data,
        productId: this.productId,
      };
    },
    // 获取产品详情
    getProductDetail: function () {
      if (this.productId) {
        this.$getJSON(apis.ProductInfoDetail, {
          productId: this.productId,
        }).then((res) => {
          this.data = res.data;

          const {
            productCode,
            productCodeId,
            productName,
            websiteCode,
            websiteName,
            country,
            countryCode,
            showOrder,
            productState,
            productDesc,
            productSn,
            productErpCode,
            productErpName,
            supportFunc = '',
          } = res.data;
          this.form = {
            productCode,
            productCodeId,
            productName,
            websiteCode,
            websiteName,
            country,
            countryCode,
            showOrder,
            productState: String(productState),
            productDesc,
            productSn,
            productErpCode,
            productErpName,
            supportFunc,
          };
          this.$emit('update', {
            productId: this.productId,
            productCode,
            productSn,
          });
        });
      }
    },
    onChangeWebsiteName(item) {
      if (item) {
        this.form.websiteName = item.websiteName;
      }
    },
    onChangeCountry(item) {
      if (item) {
        this.form.countryCode = item.placeCode;
        this.form.websiteCode = item.websiteCode;
        this.form.websiteName = item.websiteName;
      }
    },
    onChangeProductCode(item) {
      if (item) {
        this.form.productCodeId = item.productCodeId;
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.product-msg {
  padding-bottom: 60px;
  overflow: hidden;

  .product-info {
    float: left;
    width: 420px;

    .form-section {
      .el-form-item__label {
        color: #495057 !important;
        font-weight: bold;
        width: 100%;
        text-align: left;
      }

      .el-textarea__inner {
        height: 63px !important;
      }
    }

    .copy {
      float: right;
    }
  }

  .line {
    position: absolute;
    width: 1px;
    top: 24px;
    bottom: 84px;
    left: 689px;
    margin: auto;
    background: #f2f3fb;
  }

  .product-r {
    float: left;
    margin-left: 49px;
    width: 355px;

    .title {
      line-height: 28px;
      color: #495057;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .product-img {
    margin-top: 24px;
  }
}
</style>
